export default ({driver: {fhv_license_number = ''} = {}} = {}) =>
  fhv_license_number;
